/* eslint-disable max-len */
/* eslint-disable no-magic-numbers */

export enum HttpStatus {
    BadRequest = 400,
    Unauthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    InternalServerError = 500,
}

export const ERROR_400_TEXT = 'Invalid input data format. Please check'
export const ERROR_403_TEXT = 'Authorization cannot be continued. Verification failed'
export const ERROR_404_TEXT = 'Email / Password is invalid. Please check'
export const ERROR_500_TEXT = 'A server error occurred. We’re already working to fix this. Please try again later.'
export const ERROR_USER_BLOCKED_TEXT = 'Your account has been locked. To unlock your account, please contact support through our in-app chat or email us at support@banxe.com'
export const DEFAULT_GQL_SERVER_ERROR = 'Cannot return null for non-nullable field'
export const ERROR_USER_NOT_FOUND_TEXT = 'User with such email does not exist'
export const ERROR_REFERRER_CODE_NOT_FOUND = 'Referrer code not found'
export const ERROR_USER_ALREADY_REGISTERED = 'User already registered'
export const ERROR_CODE_ALREADY_SENT = 'Code has been already sent'
export const ERROR_WRONG_SMS_CODE = 'Incorrect SMS code'
export const ERROR_PHONE_ALREADY_REGISTERED = 'This device already registered'

export const HTTP_ERROR_MESSAGES: Record<HttpStatus, string> = {
    [HttpStatus.BadRequest]: ERROR_400_TEXT,
    [HttpStatus.Unauthorized]: ERROR_404_TEXT,
    [HttpStatus.Forbidden]: ERROR_403_TEXT,
    [HttpStatus.NotFound]: ERROR_404_TEXT,
    [HttpStatus.InternalServerError]: ERROR_500_TEXT,
} as const
